<p-dialog
  header="Assigned Coordinator"
  (onHide)="closeWorkflowLogsModal()"
  [position]="'top'"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="workflowLogsModal"
  [style]="{
    width: '415px',
    height: '400px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <hr class="mt-2" />
  <div *ngFor="let log of logs">
    <div *ngIf="log.requestStatus === 1">
      <span>{{ log.createdDate | date: "MM-dd-yyyy HH:mm:ss" }}</span>
      &nbsp;&nbsp;&nbsp;
      <b class="pending">Reassign request sent to {{ log.requestedOwner }}</b>
    </div>
    <div *ngIf="log.requestStatus === 2">
      <span>{{ log.createdDate | date: "MM-dd-yyyy HH:mm:ss" }}</span>
      &nbsp;&nbsp;&nbsp;
      <b class="rejected"
        >Reassign request rejected by {{ log.requestedOwner }}</b
      >
    </div>
    <div *ngIf="log.requestStatus === 3">
      <span>{{ log.createdDate | date: "MM-dd-yyyy HH:mm:ss" }}</span>
      &nbsp;&nbsp;&nbsp;
      <b class="approved"
        >Reassign request approved by {{ log.workflowOwnerName }}</b
      >
    </div>
    <div class="mt-2">
      <p>{{ log.reason }}</p>
    </div>
    <hr />
  </div>
</p-dialog>
